import { useQuery } from '@tanstack/react-query';
import { getCustomizedDataEntrySectionsForTeacher } from '../api/teachers';

const useCustomizedDataEntrySectionsForTeacher = (schoolId) => {
  return useQuery({
    queryKey: ['customizedDataEntrySectionsForTeacher', schoolId],
    queryFn: async () => {
      const result = await getCustomizedDataEntrySectionsForTeacher(schoolId);

      return Array.isArray(result) ? result : [];
    },
    // staleTime: 60000, // 1 min
    // cacheTime: 300000, // 5 min
    // enabled: !!schoolId,
    staleTime: 0,
    enabled: !!schoolId,
  });
};

export default useCustomizedDataEntrySectionsForTeacher;
